import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const GradientButton = ({ children, href, onClick, className = '', ...props }) => {
  const classes = `
    inline-flex items-center gap-2
    bg-gradient-to-r from-brand-green to-brand-blue
    text-white font-semibold px-7 py-3.5 rounded-xl
    transition-all duration-300
    hover:shadow-[0_0_30px_rgba(124,58,237,0.4)]
    active:scale-95
    ${className}
  `;

  const motionProps = {
    whileHover: { scale: 1.03 },
    whileTap: { scale: 0.97 },
  };

  if (href) {
    return (
      <motion.div {...motionProps}>
        <Link to={href} className={classes} data-testid={props['data-testid']} {...props}>
          {children}
        </Link>
      </motion.div>
    );
  }

  return (
    <motion.button className={classes} onClick={onClick} {...motionProps} {...props}>
      {children}
    </motion.button>
  );
};
